import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { axiosInstance, FilteringSortingParams, UploadTypes } from '../../utils';
import { BrollMedia } from '../../../t2c-fe/@types';

interface Payload {
  type: UploadTypes;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

interface CustomMediaResponse {
  count: number;
  recentCount: number;
  brollMedia: Array<BrollMedia>;
}

export const getCustomBrolls = async (payload: Payload): Promise<CustomMediaResponse[]> => {
  const { type, page, limit, sortBy, sortOrder } = payload;

  // Build the query parameters dynamically
  const queryParams = new URLSearchParams({
    ...(page && { pageSize: page.toString() }),
    ...(limit && { limit: limit.toString() }),
    ...(sortBy && { sortBy: sortBy.toString() }),
    ...(sortOrder && { sortOrder: sortOrder.toString() }),
  });

  try {
    const res = await axiosInstance.post(
      `/api/broll/all-custom-media${queryParams?.toString() ? '?' + queryParams.toString() : ''}`,
      { type }
    );
    return res.data;
  } catch (error) {
    console.error('Error fetching custom brolls:', error);
  }
};

export const useGetCustomBrolls = (params?: Payload) => {
  return useInfiniteQuery(
    ['getAllCustomBrolls', params],
    ({ pageParam = 1 }) => getCustomBrolls({ ...params, page: pageParam }),
    {
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = allPages.length;
        const totalItemsFetched = currentPage * (params?.limit ?? 20);

        if (totalItemsFetched < lastPage?.[0]?.count) {
          return currentPage + 1;
        } else {
          return undefined;
        }
      },
    }
  );
};
